import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './animal-species.reducer';

export const AnimalSpeciesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const animalSpeciesEntity = useAppSelector(state => state.animalSpecies.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="animalSpeciesDetailsHeading">
          <Translate contentKey="coconApp.animalSpecies.detail.title">AnimalSpecies</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{animalSpeciesEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="coconApp.animalSpecies.name">Name</Translate>
            </span>
          </dt>
          <dd>{animalSpeciesEntity.name}</dd>
        </dl>
        <Button tag={Link} to="/animal-species" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/animal-species/${animalSpeciesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AnimalSpeciesDetail;
